// extracted by mini-css-extract-plugin
module.exports = {"form":"PromocodesTable_form__2zmAN"};